import seed from '../../lib/seed-random';
seed();

/**
 * 为节点添加噪点效果，提升画面质感
 * @param {Object} renderContext - 渲染上下文，包含 context
 * @param {Object} node - 当前节点，需包含 noise 属性（0-100）
 * @param {Function} next - 下一个 effect 调用
 */
function getNoiseCanvas(w, h, noise, randomSeed = 1000) {
  // 缓存 key 只与尺寸和 noise 相关
  const cacheKey = `${w}x${h}:${noise}`;
  if (!getNoiseCanvas._cache) getNoiseCanvas._cache = new Map();
  const cache = getNoiseCanvas._cache;

  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  const imageData = ctx.createImageData(w, h);
  const data = imageData.data;

  // 使用 seedrandom 生成可复现的随机数
  let random;
  if (typeof Math.seedrandom === 'function') {
    random = new Math.seedrandom(randomSeed);
  } else {
    random = Math.random;
  }

  const threshold = noise / 100;

  for (let i = 0; i < data.length; i += 4) {
    if ((typeof random === 'function' ? random() : Math.random()) > threshold) continue;
    const value = (typeof random === 'function' ? random() : Math.random()) * 255;
    data[i] = value; // R
    data[i + 1] = value; // G
    data[i + 2] = value; // B
    data[i + 3] = value; // A
  }

  ctx.putImageData(imageData, 0, 0);
  cache.set(cacheKey, canvas);
  return canvas;
}

export function drawNoise(renderContext, node, render) {
  const { context } = renderContext;
  const noise = node.noise || 0;

  if (!noise) {
    return render();
  }

  // 计算节点实际位置和尺寸，参考其他 effect 实现
  const x = node.w < 0 ? node.x + node.w : node.x;
  const y = node.h < 0 ? node.y + node.h : node.y;
  const w = Math.abs(node.w);
  const h = Math.abs(node.h);

  if (!w || !h) {
    return render();
  }

  context.save();
  render();
  // 创建噪点画布
  const noiseCanvas = getNoiseCanvas(w, h, noise);
  // 使用 source-atop 模式仅在已渲染区域添加噪点
  // source-atop 会将新绘制的内容仅显示在已有内容的非透明区域上
  context.globalCompositeOperation = 'source-atop';
  context.globalAlpha = 0.3; // 调整噪点透明度
  context.drawImage(noiseCanvas, x, y, w, h);
  context.restore();
}
